<template>
    <div class="wrap">
        <div class="title">
            <el-breadcrumb>
                <el-breadcrumb-item>购买套餐</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
            <el-card>
                <div class="tools">
                    <div class="toolslist">
                        <ul>
                            <li v-for="item in list" :key="item.id" @click="togoqView(item)">
                                <span class="Itemleft">{{ item.name }}</span>
                                <div class="imgItem">
                                    <div>
                                        <img :src="item.url" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- 分页 -->
                    <pagination v-if="list.length > 0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />
                </div>
                <div v-if="item">
                    <div class="mainCon">
                        <ul>
                            <li v-for="(item, index) in modules" :key="index">
                                <span class="Itemleft">{{ item.name }}</span>
                                <div class="imgItem">
                                    <div>
                                        <img :src="item.url" />
                                    </div>
                                </div>
                                <p>可激活位置 ： {{ item.total }}</p>
                                <p style="margin-top: 10px">价格 ： ￥{{ item.price }}</p>
                                <p style="margin-bottom: 10px">
                                    <el-button @click="togobuy(item)">可购买</el-button>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <!-- 分页 -->
                    <pagination v-if="modules.length > 0" :total="total2" :pageNum="pageNum2" :pageSize="pageSize2" @pageChange="pageChange2" />
                </div>
            </el-card>
        </div>
        <div v-if="viewDetail">
            <togobuys ref="reftogobuys" @closeModel="initModel" :rowdetail="rowdetail"></togobuys>
        </div>
    </div>
</template>

<script>
import pagination from "@/components/pagination/index.vue";
import { toolList, packageList } from "@/api/operate/index";
import togobuys from "./common/tobuy";
export default {
    props: {},
    data() {
        return {
            viewDetail: false,
            list: [],
            item: "",
            rowdetail: {},
            pageSize: 5,
            pageNum: 0,
            total: 0,
            pageSize2: 5,
            pageNum2: 0,
            total2: 0,
            listLoading: false,
            modules: [],
        };
    },
    mounted() {
        this.gettoolList();
    },
    methods: {
        pageChange(page) {
            this.pageSize = page._pageSize;
            this.pageNum = page._currentPage;
            this.gettoolList();
        },
        pageChange2(page) {
            this.pageSize2 = page._pageSize;
            this.pageNum2 = page._currentPage;
            this.getpackageList();
        },
        initModel() {
            this.viewDetail = false;
        },
        togobuy(item) {
            this.viewDetail = true;
            this.rowdetail = item;
            this.$nextTick(() => {
                this.$refs.reftogobuys.payCreate_();
            });
        },
        togoqView(item) {
            this.item = item.id;
            this.getpackageList();
        },
        gettoolList() {
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                status: 1,
                page: this.pageNum,
                size: this.pageSize,
            };
            toolList(par).then((res) => {
                this.listLoading = false;
                if (res.code == 1) {
                    if (res.data.data.length > 0) {
                        this.list = res.data.data;
                    } else {
                        this.$message.success("暂无数据，请去添加运营工具");
                    }
                    this.total = parseInt(res.data.count);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getpackageList() {
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                name: this.ewmsetname,
                administer_tool_id: this.item,
                page: this.pageNum2,
                size: this.pageSize2,
            };
            packageList(par).then((res) => {
                this.listLoading = false;
                if (res.code == 1) {
                    if (res.data.data.length > 0) {
                        this.modules = res.data.data;
                        this.total2 = parseInt(res.data.count);
                    } else {
                        this.$message.success("暂无数据，请去添加二维码套餐");
                        this.total2 = 0;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    }, //operateManage/ewmSet
    components: {
        togobuys,
        pagination,
    },
};
</script>

<style scoped lang="scss">
.tools {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .toolslist {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        ul {
            width: 80%;
            box-sizing: border-box;
            padding-left: 42px;
            display: inline-block;
            float: left;
            margin-bottom: 50px;
            li {
                cursor: pointer;
                margin-top: 30px;
                width: 160px;
                background: #ffffff;
                border: 1px solid #dddddd;
                border-radius: 8px;
                float: left;
                margin-right: 32px;
                padding-bottom: 20px;
                p {
                    text-align: center;
                    &:nth-last-child(1) {
                        margin-top: 10px;
                        font-size: 24px;
                        font-weight: bold;
                        color: #ff2610;
                    }
                }
                .Itemleft {
                    width: 100%;
                    display: inline-block;
                    height: 31px;
                    line-height: 31px;
                    text-align: center;
                    border-radius: 4px;
                    margin: 17px 0 0 0px;
                }

                .imgItem {
                    margin: 20px 0;
                    display: flex;
                    justify-content: center;
                    // align-items: center;
                    div {
                        width: 90px;
                        height: 90px;
                        img {
                            width: 90px;
                            height: 90px;
                        }
                    }
                }
            }
        }
    }
}
.mainCon {
    margin-top: 20px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    ul {
        width: 70%;
        box-sizing: border-box;
        display: inline-block;
        float: left;
        margin-bottom: 50px;
        li {
            cursor: pointer;
            margin-top: 30px;
            width: 226px;
            background: #ffffff;
            border: 1px solid #dddddd;
            border-radius: 8px;
            float: left;
            margin-right: 32px;
            padding-bottom: 20px;
            p {
                text-align: center;
                &:nth-last-child(1) {
                    margin-top: 10px;
                    font-size: 24px;
                    font-weight: bold;
                    color: #ff2610;
                }
            }
            .Itemleft {
                width: 100%;
                display: inline-block;
                height: 31px;
                line-height: 31px;
                padding: 0 6px;
                text-align: center;
                border-radius: 4px;
                margin: 17px 0 0 0px;
            }

            .imgItem {
                margin: 20px 101px 20px 102px;
                display: flex;
                justify-content: center;
                // align-items: center;
                div {
                    width: 90px;
                    height: 90px;
                    img {
                        width: 90px;
                        height: 90px;
                    }
                }
            }
            /* &:nth-child(6n) {
                            margin-right: 0px;
                        }*/
        }
    }
}
.main {
    min-width: 1200px;
    margin: 20px;
    .el-card {
        min-height: 780px;
    }
}
ul li {
    list-style: none;
}
.title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
}
</style>
